module.exports = __webpack_public_path__ + "img/productTxtBg2.941941f2.png";